// Monthly/annual toggle for the pricing page. The page renders both price
// variants per plan ([data-price="monthly"] / [data-price="annual"]) with the
// annual ones hidden by default, so it works without JS (shows monthly). This
// flips which set is visible when the period radios change, and also rewrites
// any Pro CTA's href so the upgrade param it carries (?upgrade=monthly|annual)
// matches the currently-selected period. Without JS the CTA stays at the
// server-rendered default of monthly — acceptable degradation.
const VALID_PERIODS = new Set(["monthly", "annual"])

export function setupPricingToggle() {
  const radios = document.querySelectorAll('[data-pricing-period]')
  if (radios.length === 0) return

  function applyPeriod(period) {
    if (!VALID_PERIODS.has(period)) return
    document.querySelectorAll("[data-price]").forEach((el) => {
      el.hidden = el.dataset.price !== period
    })
    updateProCtaHrefs(period)
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) applyPeriod(radio.value)
    })
  })

  const checked = Array.from(radios).find((r) => r.checked)
  applyPeriod(checked ? checked.value : "monthly")
}

// Rewrites the `period=…` query param on any Pro CTA link to match the
// active toggle. The server renders the CTA pointing at
// /billing/checkout?period=monthly regardless of auth state — anon users
// get bounced through /login and back via the same URL.
function updateProCtaHrefs(period) {
  document.querySelectorAll("[data-pro-cta-href]").forEach((a) => {
    a.href = `/billing/checkout?period=${period}`
  })
}
